import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../../shared/config/storeConfig/StoreSchema'
import { appHandleError } from '../../../../shared/lib/appHandleError/appHandleError'
import { selectUpdateTimeFrom, selectUpdateTimeTo } from '../selectors/selectFilters'
import { IInstanceEvent } from '../types/InstanceEvent'

export const fetchInstanceEvents = createAsyncThunk<
	IInstanceEvent[],
	string,
	ThunkConfig<string>
>('instanceEvents/fetchInstanceEvents', async (licenseId, thunkAPI) => {

	const { extra: { api }, rejectWithValue, getState } = thunkAPI

	const updateTimeFrom = selectUpdateTimeFrom(getState())
	const updateTimeTo = selectUpdateTimeTo(getState())

	try {
		const { data } = await api.get<{
			items: IInstanceEvent[]
		}>(`/licenses/${licenseId}/instances/activity-log`, {
			params: {
				updateTimeFrom,
				updateTimeTo
			}
		})

		if (!Array.isArray(data?.items)) {
			console.warn('fetchInstanceEvents: unexpected response shape', data)
			return [] as IInstanceEvent[]
		}
		return data.items
	} catch (e) {
		console.log(e)
		appHandleError(e, 'fetchInstanceEvents', 'Failed to fetch instance events')
		return rejectWithValue('Error occurred on fetching instance events')
	}
})